export const inboundFreightStatusOptions = [
    { label: "Arrived", value: "ARRIVED" },
    { label: "Inbound", value: "INBOUND" },
    { label: "Late", value: "LATE" },
    { label: "Alert", value: "ALERT" }
];

export interface InboundPickupSummaryResponse {
    serviceCenter: ServiceCenter;
    assignedSummary: PickupSummary | null;
    unassignedSummary: PickupSummary | null;
    completedSummary: PickupSummary | null;
}

export interface ServiceCenter {
    terminalNumber: number;
    terminalName: string;
    airportCode: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipcode: number;
    terminalRegion: string;
    terminalTimeZone: string;
    managerName: string;
    managerPhoneNumber: string;
    managerEmail: string;
    terminalEmail: string;
    hub: string;
    hubNumb: string;
    primary: boolean;
}

export interface PickupSummary {
    destinationTerminal: number;
    totalPickups: number;
    totalItems: number;
    totalWeight: number;
    totalDrivers: number;
}

export interface InboundFreightSummary {
  originTerminalNumber: number;
  originTerminalName: string;
  originAirportCode: string;
  numberOfShipments: number;
  numberOfPieces: number;
  weight: number;
  numberOfTrailers: number;
  earliestEta: string; // YYYY-MM-DD
  latestEta: string;   // YYYY-MM-DD
}

export interface DestinationFreightSummary {
  destinationTerminal: number;
  destinationName: string;
  destinationAirportCode: string;
  pros: number;
  pieces: number;
  weight: number;
  squareYards: number;
  revenue: number;
  earliestEta: string; // YYYY-MM-DD
  latestEta: string;   // YYYY-MM-DD
}
